import type { FC } from 'react';

import { Segmented } from 'antd';
import classNames from 'classnames';

import type { EViewMode } from '../../constants';
import { VIEW_MODE_OPTIONS } from './options';

interface IPreviewSwitcherProps {
  className?: string;
  value: EViewMode;
  onChange: (value: EViewMode) => void;
}

export const PreviewSwitcher: FC<IPreviewSwitcherProps> = ({ value, onChange, className }) => {
  return (
    <div
      className={classNames(
        '[&_.ant-segmented]:!p-1 [&_.ant-segmented]:!rounded-xl',
        'max-sm:[&_.ant-segmented]:!w-full',
        className
      )}
    >
      <Segmented<EViewMode>
        value={value}
        options={VIEW_MODE_OPTIONS}
        onChange={onChange}
      />
    </div>
  );
};
